// src/services/diseaseDiagnosisApi.js
import apiService from './apiService';

const diseaseDiagnosisApi = {
  diagnose: (data) => apiService.post('/diseases/diagnose', data),
  getMine: () => apiService.get('/diseases/diagnoses/mine'),
  getAll: () => apiService.get('/diseases/diagnoses'), // admin only
};

export default diseaseDiagnosisApi;
